import MainLayout from "../../common/components/MainLayout"
import InfractoresList from "../components/InfractoresList"

export default () => {
    

    return (<MainLayout>
        <InfractoresList/>
    </MainLayout>)

}